import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#0ea5e9',
    },
    background: {
      default: '#0c0c0c',
      paper: '#161616',
    },
  },
  shape: {
    borderRadius: 12,
  },
});
